import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ControlledRadioGroup, Fieldset } from '@components';

export const CreditScore = () => {
  const { t } = useTranslation('subModules/creditScore');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };
  const scores: { [key: string]: string } = t('scores', {
    returnObjects: true,
  }) as { [key: string]: string };

  // Color mapping for credit score indicators
  const scoreColorMap: { [key: string]: string } = {
    EXCELLENT: 'custom.creditScoreExcellent',
    VERY_GOOD: 'custom.creditScoreVeryGood',
    GOOD: 'custom.creditScoreGood',
    FAIR: 'custom.creditScoreFair',
    POOR: 'custom.creditScorePoor',
  };

  const renderLabelSuffix = (key: string) => {
    if (!scores[key]) {
      return null;
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          sx={{
            fontSize: '14px',
            color: 'custom.inputLabel',
            fontWeight: 700,
          }}
        >
          {scores[key]}
        </Typography>
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: '50%',
            bgcolor: scoreColorMap[key],
            flexShrink: 0,
          }}
        />
      </Box>
    );
  };

  return (
    <Fieldset label={t('label')} required>
      <ControlledRadioGroup
        name="creditScore"
        fields={fields}
        aria-labelledby="credit-score-radio-buttons"
        data-testid="creditScoreSubModule"
        data-tf-sensitive="true"
        renderLabelSuffix={renderLabelSuffix}
      />
    </Fieldset>
  );
};
